const formatUSD = (value) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value)
}

export const parseUSD = (formattedValue) => {
    if (typeof formattedValue !== 'string') {
        return formattedValue
    }

    const parsedValue = parseFloat(formattedValue.replace(/[^\d.-]/g, ''));

    if (isNaN(parsedValue)) {
        return formattedValue
    }

    return parsedValue;
};

export const filterGreaterOrLessThan = (arrayValues, valueCompare, less) => {
    if (!Array.isArray(arrayValues)) {
        return []
    }

    if (typeof valueCompare !== 'number') {
        return []
    }

    return arrayValues.filter(value => !less ? value < valueCompare : value > valueCompare);
}

export const convertMoneyAndTruncateOrRound = (value = 0) => {

    /* const parts = value?.toString().split('.')

    if (parts.length === 1) {
        value = parseFloat(value.toFixed(2))
    } else {
        const decimalPart = parts[1];
        if (decimalPart[0] > 5) {
            value = Math.ceil(value * 10) / 10;
        } else {
            value = Math.floor(value * 10) / 10;
        }
    } */

    return formatUSD(value)

}

export const getQuoteId = (context) => {
    if (
        !context ||
        !context.calculation ||
        !context.calculation.data ||
        !context.calculation.data.quotation ||
        !context.calculation.data.quotation.id
    ) {
        return null;
    }

    return context.calculation.data.quotation.id;
}

export const formatBenefitValue = (value, type) => {

    const listFormats = {
        currency: (val) => formatUSD(val),
        percentage: (val) => `${val}%`
    }

    return listFormats[type] ? listFormats[type](value) : value.toString()

}

export const filterBenefitsByBenefitId = (benefits, valueCompare ,idBenefit, less = false) => {
    
    const allBenefits = benefits.filter((i) => i["factorId.id"] === idBenefit);

    const arrayValues = allBenefits.map(benefit => benefit.description ? parseUSD(benefit.description) : null)

    return filterGreaterOrLessThan(arrayValues, valueCompare, less)
        .map(value => `${idBenefit}_${value}`);
};

export const getValueByBenefitId = (contextState, idBenefit) => {
    return parseUSD(contextState.selectedBenefitsNames?.[idBenefit]);
}

export const hasDependantInCountry = (dependants, country) => {
    return dependants.filter( dependant => dependant.country === country ).length > 0
}
